import { render, staticRenderFns } from "./AlertDropdown.vue?vue&type=template&id=0b80943d&scoped=true&"
import script from "./AlertDropdown.vue?vue&type=script&lang=js&"
export * from "./AlertDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AlertDropdown.vue?vue&type=style&index=0&id=0b80943d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80943d",
  null
  
)

export default component.exports